import React, { useState } from 'react';
import { navigate } from 'gatsby';
import { Box, Stack, Drawer, AppBar, Toolbar, Container } from '@mui/material';

import CBXLogo from '../Icons/CBXLogo';
import Searchbar from '../Searchbar';
import AccountMenu from '../AccountMenu';
import LanguageSelector from '../LanguageSelector';
import ShowShoppingCartButton from '../ShowShoppingCartButton';

import CloseButton from './CloseButton';
import BurgerButton from './BurgerButton';
import MobileNavbarLinks from './MobileNavbarLinks';
import DesktopNavbarLinks from './DesktopNavbarLinks';
import { useIsMobile } from '../../hooks';

export default function Navbar({ firebase, uid, user }) {
  const isMobile = useIsMobile();

  const [searchTerm, setSearchTerm] = useState('');
  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = (isOpen) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setDrawerOpen(isOpen);
  };

  const handleSearch = (event) => {
    event.preventDefault();
    // TODO: Implement the search logic
  };

  const handleInputChange = (event) => {
    setSearchTerm(event.target.value);
  };

  return (
    <>
      <AppBar
        sx={{
          bgcolor: '#FEFEFE',
          borderBottom: '1px solid #DADADA',
          borderRadius: 0,
        }}
        color="transparent"
        position="sticky"
        elevation={0}
      >
        <Toolbar sx={{ height: { xs: 68, md: 72 }, py: '12px' }} maxWidth="xl" component={Container} disableGutters>
          {isMobile && (
            <>
              <BurgerButton onClick={toggleDrawer(true)} />

              <Stack flexGrow={1} alignItems="center" justifyContent="center">
                <Box height="fit-content" onClick={() => navigate('/')} sx={{ cursor: 'pointer' }}>
                  <CBXLogo />
                </Box>
              </Stack>

              <Stack direction="row" justifyContent="center" gap="24px">
                <AccountMenu user={user} uid={uid} firebase={firebase} />
                <ShowShoppingCartButton firebase={firebase} user={user} uid={uid} />
              </Stack>
            </>
          )}

          {!isMobile && (
            <>
              <Stack gap="32px" flexGrow={1} direction="row" alignItems="center">
                <Box height="fit-content" onClick={() => navigate('/')} sx={{ cursor: 'pointer' }}>
                  <CBXLogo />
                </Box>
                <DesktopNavbarLinks />
                {false && <Searchbar onSearch={handleSearch} searchTerm={searchTerm} onInputChange={handleInputChange} />}
              </Stack>
              <Stack gap="48px" direction="row" alignItems="center">
                <AccountMenu user={user} uid={uid} firebase={firebase} />
                <ShowShoppingCartButton firebase={firebase} user={user} uid={uid} />
                <LanguageSelector />
              </Stack>
            </>
          )}
        </Toolbar>
      </AppBar>

      {/* Drawer for mobile */}
      <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
        <Box sx={{ width: '100vw' }} role="presentation">
          <Toolbar
            sx={{ py: '12px', borderBottom: '1px solid #DADADA' }}
            maxWidth="xl"
            component={Container}
            disableGutters
          >
            <Box height="fit-content" onClick={() => navigate('/')} sx={{ cursor: 'pointer' }}>
              <CBXLogo />
            </Box>
            <Stack gap="24px" flexGrow={1} direction="row" alignItems="center" justifyContent="flex-end">
              <LanguageSelector />
              <CloseButton onClick={toggleDrawer(false)} />
            </Stack>
          </Toolbar>
          <Stack padding="16px" gap="24px">
            <Searchbar onSearch={handleSearch} searchTerm={searchTerm} onInputChange={handleInputChange} />
            <MobileNavbarLinks />
          </Stack>
        </Box>
      </Drawer>
    </>
  );
}
